import { ReportingOption } from 'src/components/enterprise/features/Corporate/components/Form/types/CorporateForm';

export type ReportingRequirements = {
  dinerLocationRequired: boolean;
  dinerDepartmentRequired: boolean;
};

export function getReportingRequirements(
  reportingOption: ReportingOption
): ReportingRequirements {
  let dinerLocationRequired = false;
  let dinerDepartmentRequired = false;

  switch (reportingOption) {
    case ReportingOption.LOCATIONS_REPORTING_OPTION:
      dinerLocationRequired = true;
      dinerDepartmentRequired = false;
      break;
    case ReportingOption.DEPARTMENTS_REPORTING_OPTION:
      dinerLocationRequired = false;
      dinerDepartmentRequired = true;
      break;
    case ReportingOption.NONE_REPORTING_OPTION:
    default:
      dinerLocationRequired = false;
      dinerDepartmentRequired = false;
      break;
  }

  return { dinerLocationRequired, dinerDepartmentRequired };
}

export type UploadEmployeeType = {
  dinerLocationRequired: boolean;
  dinerDepartmentRequired: boolean;
};

export function transformUploadEmployeeUIToModel(
  reportingOption: ReportingOption,
  dinerLocationRequired: boolean,
  dinerDepartmentRequired: boolean
): UploadEmployeeType {
  switch (reportingOption) {
    case ReportingOption.LOCATIONS_REPORTING_OPTION:
    case ReportingOption.DEPARTMENTS_REPORTING_OPTION:
      return {
        dinerLocationRequired: false,
        dinerDepartmentRequired: false,
      };
    case ReportingOption.NONE_REPORTING_OPTION:
    default:
      return {
        dinerLocationRequired,
        dinerDepartmentRequired,
      };
  }
}

export function transformUploadEmployeeModelToUI(
  reportingOption: ReportingOption,
  dinerLocationRequired: boolean,
  dinerDepartmentRequired: boolean
): UploadEmployeeType {
  switch (reportingOption) {
    case ReportingOption.LOCATIONS_REPORTING_OPTION:
      return {
        dinerLocationRequired: true,
        dinerDepartmentRequired: false,
      };
    case ReportingOption.DEPARTMENTS_REPORTING_OPTION:
      return {
        dinerLocationRequired: false,
        dinerDepartmentRequired: true,
      };
    case ReportingOption.NONE_REPORTING_OPTION:
    default:
      return {
        dinerLocationRequired,
        dinerDepartmentRequired,
      };
  }
}
